
<template>
  <!--访客记录详情-->
  <div class="visitor-form">
    <a-form :form="form">
      <div class="card" v-for="(item, index) in deviceInfoList" :key="index">
        <div class="card-head">
          <h3>{{item[0]}}</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item1, index1) in item[1]" :key="index1" v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" :label="item1.label">
                <span class="ant-form-text">{{item1.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    <a-descriptions title="通行记录"></a-descriptions>
      <x-tabula
        apiOrigin="PHP"
        ref="table"
        :dataSource="dataSource"
        rowKey="recode_detai_id"
        :columns="columns"
        :tableOptList="tableOptList"
        :rowOptList="rowOptList"
        :deleteParam="deleteParam"
        :rowSelection="false"
      >
      </x-tabula>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'recordDetail',
  data () {
    return {
      deviceInfoList: [
        [
          '基本信息',
          [
            {key: 'type_desc', label: '类型', value: ''},
            {key: 'status_desc', label: '状态', value: ''},
            {key: 'create_time', label: '创建时间', value: ''},
            { key: 'register_location_desc', label: '登记点', value: '' }
          ]
        ],
        [
          '被访者信息',
          [
            { key: 'household_name', label: '姓名', value: '' },
            { key: 'household_phone', label: '手机', value: '' },
            { key: 'room_desc', label: '房间', value: '' }
          ]
        ],
        [
          '访客信息',
          [
            { key: 'visitor_name', label: '姓名', value: '' },
            { key: 'visitor_phone', label: '联系电话', value: '' },
            { key: 'visit_reason', label: '来访事由', value: '' },
            { key: 'visitor_time', label: '来访时间', value: '' },
            { key: 'visitor_num', label: '来访人数', value: '' }
          ]
        ]
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.showPicture(row.face_img), key: 'show' }
      ],
      columns: [
        { title: '开门时间', dataIndex: 'open_time', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'door_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '抓拍', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      deleteParam: {}
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this._get({
        url: `/visitor_record/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        this.dataSource = data.open_logs;
        this.deviceInfoList.forEach(item => {
          item[1].forEach(el => {
            for (let item in data) {
              if (el.key === item) {
                el.value = data[item];
              }
            }
          });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.card-head{
  h3{color: #000;font-weight: 650;}
}
.advanced-form .card:not(.list-card) {margin-bottom: 0;}
.visitor-form /deep/ .ant-descriptions-title { margin-bottom: 0;}
.ant-form-text{ padding-left: 8px;}
</style>
